/* eslint-disable @typescript-eslint/no-unused-vars */
import './styles.modules.scss';
import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import HorizontalSlider from '../HorizontalSlider';
import InstantSearchProvider, {
  useInstantSearch,
} from '../InstantSearchProvider';
import { BRAND_SEARCH_INDEX_FEATURED } from '~constants/search';
import { BrandReadModel } from '~types/api';
import { getPublicImageUrl } from '~utils/image';

const BrandSlider: React.FC = React.memo(() => {
  const { hits: brands } = useInstantSearch<BrandReadModel>();
  return (
    <HorizontalSlider>
      {brands.map((brand) => (
        <div styleName="brands-image">
          <Link to={`/brand/${brand.id}`} className="w-100">
            <div styleName="brand-image">
              <img
                src={getPublicImageUrl(brand.brand_icon_imageKey, {
                  w: 250,
                  h: 250,
                })}
                alt="brand image"
                className="mb-2"
                loading="lazy"
              />
            </div>
            <div className="font-weight-bold" translate="no">
              {brand.brand_name}
            </div>
            <small className="text-black-50">{brand.brand_category}</small>
          </Link>
        </div>
      ))}
    </HorizontalSlider>
  );
});

const HomeBrands: React.FC = () => {
  return (
    <Container styleName="brands-container">
      <h3>Featured brands</h3>
      <InstantSearchProvider
        indexName={BRAND_SEARCH_INDEX_FEATURED}
        hitsPerPage={50}
        filters={`category_page_id:brands`}
      >
        <BrandSlider />
      </InstantSearchProvider>
    </Container>
  );
};

export default HomeBrands;
